var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Webcam from 'react-webcam';
import { DialogPosition } from '../../models';
import { renderIcon } from '../../utils';
import { Dialog } from '../dialog/dialog';
import { PictureIcon, FlipArrowIcon } from './icons';
export var Camera = function (_a) {
    var onGetPhoto = _a.onGetPhoto, onClose = _a.onClose;
    var _b = useState('user'), facingMode = _b[0], setFacingMode = _b[1];
    var _c = useState(false), isAllowedSwitchCamera = _c[0], setIsAllowedSwitchCamera = _c[1];
    var _d = useState(''), preview = _d[0], setPreview = _d[1];
    var videoConstraints = {
        width: 480,
        height: 720,
        aspectRatio: 0.67,
        facingMode: facingMode,
    };
    var onSwitchCamera = function () {
        if (isAllowedSwitchCamera) {
            setFacingMode(function (prevState) {
                return prevState === 'user' ? { exact: 'environment' } : 'user';
            });
        }
    };
    var handleImageUpload = function (event) {
        var target = event.target;
        var file = target.files[0];
        var reader = new FileReader();
        reader.addEventListener('load', function () {
            onGetPhoto(String(reader.result));
            onClose();
        }, false);
        reader.readAsDataURL(file);
    };
    var onClear = function () {
        setPreview('');
    };
    var onSubmit = function () {
        onGetPhoto(String(preview));
        onClose();
    };
    useEffect(function () {
        var _a;
        var gotDevices = function (mediaDevices) {
            var availableVideoInputs = [];
            mediaDevices.forEach(function (mediaDevice) {
                if (mediaDevice.kind === 'videoinput') {
                    availableVideoInputs.push({
                        deviceId: mediaDevice.deviceId,
                        label: mediaDevice.label,
                    });
                }
            });
            if (availableVideoInputs.length > 1) {
                setIsAllowedSwitchCamera(true);
            }
            else {
                setIsAllowedSwitchCamera(false);
            }
        };
        (_a = navigator === null || navigator === void 0 ? void 0 : navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.enumerateDevices().then(gotDevices);
    }, []);
    return (_jsx(Dialog, __assign({ fullScreen: true, visible: true, position: DialogPosition.Top }, { children: _jsxs("div", __assign({ className: "relative flex h-full w-full flex-col items-center justify-evenly\tbg-black" }, { children: [_jsx("button", __assign({ className: 'absolute top-0 ml-6 mt-8 self-start', onClick: onClose }, { children: renderIcon('XIcon', 'w-6 h-6 text-white hover:text-uiLight') })), preview ? (_jsx("div", __assign({ className: "mt-10 grid content-center", style: { height: '70%', marginTop: 40 } }, { children: _jsx("img", { alt: "preview", src: String(preview) }) }))) : (_jsx(Webcam, __assign({ className: "mt-10", audio: false, screenshotFormat: "image/jpeg", videoConstraints: videoConstraints }, { children: function (_a) {
                        var getScreenshot = _a.getScreenshot;
                        return (_jsxs("div", __assign({ className: "mirrored flex w-full items-center justify-evenly" }, { children: [_jsx("input", { id: "actual-btn", type: "file", onChange: handleImageUpload, accept: "image/*", hidden: true }), _jsxs("label", __assign({ htmlFor: "actual-btn", className: "relative flex items-center" }, { children: [_jsx("span", { className: "z-1 absolute h-8 w-10 rounded-md bg-white" }), _jsx(PictureIcon, {})] })), _jsx("button", { onClick: function () {
                                        var imageSrc = getScreenshot();
                                        setPreview(imageSrc);
                                    }, className: "h-24 w-24 rounded-full border-8 bg-white" }), _jsx("button", __assign({ className: "flex h-10 w-10 items-center justify-center rounded-xl bg-white", onClick: onSwitchCamera }, { children: _jsx(FlipArrowIcon, {}) }))] })));
                    } }))), preview && (_jsxs("div", __assign({ className: "flex w-full justify-between px-6" }, { children: [_jsx("button", __assign({ className: "h-14 w-14", onClick: onClear }, { children: renderIcon('XCircleIcon', 'h-full w-full text-uiBg') })), _jsx("button", __assign({ className: "h-14 w-14", onClick: onSubmit }, { children: renderIcon('CheckCircleIcon', 'h-full w-full text-successMain') }))] })))] })) })));
};
//# sourceMappingURL=index.js.map